import { buildWhatsAppLink } from "@/config/site";
import { track } from "@/lib/analytics";

export default function WhatsAppButton() {
  const href = buildWhatsAppLink();

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Fale com a PlayMenu no WhatsApp"
      onClick={() => track("whatsapp_click", { location: "floating" })}
      className="group fixed bottom-6 right-6 z-50 flex items-center md:bottom-6 md:right-6"
      style={{ bottom: "18px", right: "18px" }}
    >
      {/* Tooltip */}
      <span className="pointer-events-none mr-3 hidden whitespace-nowrap rounded-full bg-foreground-950 px-4 py-2 text-sm font-medium text-foreground-50 opacity-0 shadow-sm transition-opacity duration-200 group-hover:opacity-100 md:block">
        Fale com a PlayMenu
      </span>

      {/* Anel de pulso */}
      <span className="absolute right-0 top-0 flex h-14 w-14 animate-pulse-soft rounded-full bg-[#25D366]/40" />

      <span className="relative flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-foreground-950 transition-transform hover:scale-105">
        <i className="ri-whatsapp-line text-2xl" aria-hidden="true" />
      </span>
    </a>
  );
}